import { MISSION_ENUM_TYPES } from '../../../../../shared/constants'

export const WITHHOLD_OPTIONS_LABEL_ENUM = {
  ALL: 'ALL',
  OFF: 'Withhold OFF',
  ON: 'Withhold ON',
}

export const WITHHOLD_OPTIONS_VALUE_ENUM = {
  ALL: 'ALL',
  OFF: 'OFF',
  ON: 'ON',
}

export const withholdPayOptions = [
  {
    label: WITHHOLD_OPTIONS_LABEL_ENUM.ALL,
    value: WITHHOLD_OPTIONS_VALUE_ENUM.ALL,
  },
  {
    label: WITHHOLD_OPTIONS_LABEL_ENUM.OFF,
    value: WITHHOLD_OPTIONS_VALUE_ENUM.OFF,
  },
  {
    label: WITHHOLD_OPTIONS_LABEL_ENUM.ON,
    value: WITHHOLD_OPTIONS_VALUE_ENUM.ON,
  },
]

export const restrictedMissionTypeOptions = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Hand to Hand',
    value: MISSION_ENUM_TYPES.HANDTOHAND,
  },
  {
    label: 'Letterbox',
    value: MISSION_ENUM_TYPES.LETTERBOX,
  },
]
